var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_3790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 10.6172L20.1523 13.2116L12.1719 13.7602L5.16179 14.2243L0.5 10.6172L2.60938 4.28906L12.1719 1.47656L12.3827 1.41321L21.7344 4.28906L23.8438 10.6172Z",
    fill: "#FAECD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 10.6172L20.1523 13.2116L12.1719 13.7602V1.47656L12.3827 1.41321L21.7344 4.28906L23.8438 10.6172Z",
    fill: "#F4D7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60938 0V4.28906H21.7344V0H2.60938Z",
    fill: "#759F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 0H12.1719V4.28906H21.7344V0Z",
    fill: "#395334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.6172V36H21.7344C22.8994 36 23.8438 35.0556 23.8438 33.8906V10.6172H0.5Z",
    fill: "#759F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 10.6172V33.8906C23.8438 35.0556 22.8994 36 21.7344 36H12.1719V10.6172H23.8438Z",
    fill: "#395334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 17.2406L12.1719 16.5445L11.4546 17.2407C10.6953 17.9577 6.89844 21.6703 6.89844 24.3281C6.89844 27.2391 9.26094 29.6016 12.1719 29.6016C15.0828 29.6016 17.4453 27.2391 17.4453 24.3281C17.4453 21.6703 13.6484 17.9577 12.8891 17.2406Z",
    fill: "#FAECD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4453 24.3281C17.4453 27.2391 15.0828 29.6016 12.1719 29.6016V16.5445L12.8891 17.2407C13.6484 17.9577 17.4453 21.6703 17.4453 24.3281Z",
    fill: "#F4D7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 19.0547L36.4789 26.2266L34.7071 29.3062C34.2219 29.4539 33.6102 29.5805 32.8719 29.5805C31.543 29.5805 29.8766 29.1797 28.0625 27.8087C27.8305 27.6188 27.5985 27.4288 27.3663 27.218C25.468 25.5516 23.5695 25.0454 21.671 25.6993L19.625 24.2648V19.0547H36.5Z",
    fill: "#E0F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 19.0547L36.4789 26.2266L34.7071 29.3062C34.2219 29.4539 33.6102 29.5805 32.8719 29.5805C31.543 29.5805 29.8766 29.1797 28.0625 27.8087V19.0547H36.5Z",
    fill: "#BBDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6015 27.1125C33.7789 27.4922 31.543 28.1461 28.7586 25.657C28.5265 25.4462 28.2945 25.2562 28.0624 25.0874C25.5734 23.1891 22.8101 22.7883 20.2366 23.9906L19.625 24.2648V26.4375L21.9664 36H34.1586L35.9516 28.8L36.4789 26.6906V26.2266L34.6015 27.1125Z",
    fill: "#FAECD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4789 26.2266V26.6906L35.9516 28.8L34.1586 36H28.0625V25.0875C28.2945 25.2563 28.5265 25.4462 28.7587 25.6571C31.543 28.1462 33.779 27.4923 34.6016 27.1126L36.4789 26.2266Z",
    fill: "#F4D7AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_3790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.3c2fbd676d330ce876faebacb7c71a4d.svg";
export { ForwardRef as ReactComponent };